/* Debounced search box for the admin list panels.
 * Calls `onSearch(term)` ~280ms after the operator stops typing so the
 * backend isn't hammered on every keystroke. Renders a small clear-X
 * button when the box is non-empty. */
import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

const AdminSearchBar = ({ placeholder, onSearch, initialValue = "" }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const id = setTimeout(() => onSearch((value || "").trim()), 280);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div
      data-testid="admin-search-bar"
      className="relative w-full sm:max-w-md"
    >
      <Search
        size={14}
        strokeWidth={1.6}
        aria-hidden
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ld-ink-muted)] pointer-events-none"
      />
      <input
        data-testid="admin-search-input"
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className="w-full pl-9 pr-9 py-2 bg-transparent border border-[var(--ld-ink)]/30 text-[13px] text-[var(--ld-ink)] placeholder:text-[var(--ld-ink-muted)] focus:outline-none focus:border-[var(--ld-gold-deep)] transition-colors"
      />
      {value && (
        <button
          type="button"
          data-testid="admin-search-clear"
          onClick={() => setValue("")}
          aria-label="Clear search"
          className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex h-5 w-5 items-center justify-center text-[var(--ld-ink-muted)] hover:text-[var(--ld-ink)]"
        >
          <X size={13} strokeWidth={1.8} />
        </button>
      )}
    </div>
  );
};

export default AdminSearchBar;
